<template>
  <div
    v-if="data"
    class="mission-page"
    :class="{ 'has-bet-sheet': selectedCount() > 0 }"
  >
    <header class="mission-header">
      <button
        type="button"
        class="header-btn"
        @click="$router.push('/user')"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ data?.title }}</h1>
      <button
        type="button"
        class="header-btn"
        @click="$router.push('/order')"
      >
        <van-icon
          name="orders-o"
          size="22"
        />
      </button>
    </header>

    <main class="mission-content">
      <section class="round-section" >
        <!--    <div class="round-label">
          {{ $t('buyMission.currentSponsorshipRound') }}
        </div> -->
       <div class="round-title">
          <strong> {{ $t('utils.count_down') }}</strong>
        </div>
        <div class="round-time">
          <van-count-down
            :time="data && data.time ? data.time * 1000 : 0"
            @finish="finish"
          >
            <template #default="timeData">
              {{ formatCountdown(timeData) }}
            </template>
          </van-count-down>
        </div>
      </section>

      <div class="round-bar">
        <strong>
          <!-- {{ periodCode() }} -->
          <span
            class="result-pill"
            style="background: none;color: #000;"
            :class="'is-' + topit?.firstKey"
          >{{ topit?.first }}</span>
          <span
            class="result-pill "
            :class="'is-' + topit?.secondKey"
            style="margin-left: 10px;background: none;color: #000;"
          >{{ topit?.second }}</span>
        </strong>
        <button
          type="button"
          class="history-toggle"
          @click="toggleHistory"
        >
          {{ $t('buyMission.sponsorshipResults') }}
          <van-icon :name="historyOpen ? 'arrow-up' : 'arrow-down'" />
        </button>
      </div>

      <section
        v-if="historyOpen"
        class="history-board"
      >
        <div
          v-for="(item, historyIndex) in historyList()"
          :key="historyIndex"
          class="history-row"
        >
          <!-- <span class="history-digits">
            <b
              v-for="(digit, digitIndex) in item.digits"
              :key="digitIndex"
            >{{ digit }}</b>
          </span>
          <span class="history-total">{{ item.total }}</span> -->
          <span
            class="result-pill"
            :class="'is-' + item.firstKey"
          >{{ item.first }}</span>
          <span
            class="result-pill"
            :class="'is-' + item.secondKey"
          >{{ item.second }}</span>
        </div>
      </section>

      <section
        v-else
        class="reservation-panel"
      >
        <h2>{{ $t('buyMission.managerReservation') }}</h2>
        <div class="option-grid">
          <button
            type="button"
            class="mission-option"
            :class="{ checked: da == 1 }"
            @click="toggleOption('da')"
          >
            <img
              v-if="hasOptionImage('p1')"
              :src="optionImageSource('p1')"
              alt=""
              @error="markOptionImageFailed('p1')"
            >
            <span
              v-else
              class="option-image-placeholder"
            >
              <van-icon name="photo-o" />
            </span>
            <span>{{ $t('buyMission.rose') }}</span>
          </button>
          <button
            type="button"
            class="mission-option"
            :class="{ checked: xiao == 1 }"
            @click="toggleOption('xiao')"
          >
            <img
              v-if="hasOptionImage('p2')"
              :src="optionImageSource('p2')"
              alt=""
              @error="markOptionImageFailed('p2')"
            >
            <span
              v-else
              class="option-image-placeholder"
            >
              <van-icon name="photo-o" />
            </span>
            <span>{{ $t('buyMission.lily') }}</span>
          </button>
          <button
            type="button"
            class="mission-option"
            :class="{ checked: dan == 1 }"
            @click="toggleOption('dan')"
          >
            <img
              v-if="hasOptionImage('p3')"
              :src="optionImageSource('p3')"
              alt=""
              @error="markOptionImageFailed('p3')"
            >
            <span
              v-else
              class="option-image-placeholder"
            >
              <van-icon name="photo-o" />
            </span>
            <span>{{ $t('buyMission.fireworks') }}</span>
          </button>
          <button
            type="button"
            class="mission-option"
            :class="{ checked: shuang == 1 }"
            @click="toggleOption('shuang')"
          >
            <img
              v-if="hasOptionImage('p4')"
              :src="optionImageSource('p4')"
              alt=""
              @error="markOptionImageFailed('p4')"
            >
            <span
              v-else
              class="option-image-placeholder"
            >
              <van-icon name="photo-o" />
            </span>
            <span>{{ $t('buyMission.balloon') }}</span>
          </button>
        </div>
      </section>
    </main>

    <div
      v-if="!historyOpen && liveVoteDisplayList.length"
      class="live-vote-panel"
    >
      <div class="live-vote-title">
        {{ $t('pro2.livevote') }}
      </div>
      <div class="live-vote-body">
        <div class="live-vote-track">
          <div
            v-for="(item, index) in liveVoteDisplayList"
            :key="index"
            class="live-vote-row"
          >
            {{ item.message }} {{ item.code }}
          </div>
        </div>
      </div>
    </div>
	
    <div
      v-if="selectedCount() > 0"
      class="bet-sheet"
    >
      <div class="bet-title">
        <span />
        {{ selectedCount() }} {{ ticketLabel }}
		
        <span v-if="selectedMoney()>0">， {{ $t('pro.ordersum') }}： {{ selectedMoney() }}</span>
      </div>
      <div class="bet-form">
        <label>{{ $t('buyMission.perSlipPoints') }}:</label>
        <input
          v-model.trim="num"
          type="number"
          min="1"
          step="1000"
          :placeholder="$t('pro2.enteramount')"
          class="bet-input"
        >
      </div>
      <button
        type="button"
        class="bet-submit"
        :class="{ disabled: submitting }"
        :disabled="submitting"
        @click="buy"
      >
        {{ $t('buyMission.confirmSubmit') }}
      </button>
    </div>

    <van-overlay
      :show="show1"
      @click="show1 = false"
    >
      <div
        class="wrapper1"
        @click.stop
      >
        <div class="block">
          <van-circle
            v-model="currentRate"
            :stroke-width="60"
            rate="0"
            size="100%"
            :color="gradientColor"
            :text="$t('pro2.loading')"
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
	import Fetch from "../../utils/fetch";
	import Vue from 'vue';
	import {
		Overlay,
		Circle,
		Dialog,
		CountDown,
		Icon,
		Toast
	} from 'vant';

	Vue.use(Overlay)
		.use(Circle)
		.use(Dialog)
		.use(CountDown)
		.use(Icon)
		.use(Toast);

	export default {
		name: "Buy",
		data() {
			return {
				show1: false,
				submitting: false,
				currentRate: 0,
				gradientColor: {
					'0%': '#ff5d7a',
					'100%': '#ff7791'
				},
				data: null,
				index: 0,
				acc: null,
				topit:null,
				show_tz: false,
				num: '',
				da: 0,
				xiao: 0,
				dan: 0,
				shuang: 0,
				kai: null,
				items: null,
				kais: null,
				imgs: null,
				historyOpen: false,
				optionImageErrors: {
					p1: false,
					p2: false,
					p3: false,
					p4: false
				},
				liveVoteList: [],
				liveVoteDisplayList: [],
				time: 5000000
			};
		},
		computed: {
			ticketLabel() {
				return this.selectedCount() === 1 ? this.$t('buyMission.ticketSelected') : this.$t('buyMission.ticketsSelected');
			}
		},
		created() {
			this.$parent.footer('item', false);
		},
		mounted() {
			this.index = this.$router.history.current.params.code;
			this.start();
			this.accinfo();
			this.generateLiveVotes();
		},
		methods: {
			generateLiveVotes() {
				var messages = [
					this.$t('pro2.voteMsgFirst'),
					this.$t('pro2.voteMsgSecond'),
					this.$t('pro2.voteMsgFirstDone'),
					this.$t('pro2.voteMsgSecondDone'),
					this.$t('pro2.voteMsgFirst')
				];
				var list = [];
				for (var i = 0; i < 12; i++) {
					list.push({
						message: messages[Math.floor(Math.random() * messages.length)],
						code: this.createVoteCode(i)
					});
				}
				this.liveVoteList = list;
				this.liveVoteDisplayList = list.concat(list);
			},
			createVoteCode(index) {
				var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
				var first = letters[(index + Math.floor(Math.random() * letters.length)) % letters.length];
				var second = letters[Math.floor(Math.random() * letters.length)];
				var num = Math.floor(Math.random() * 9) + 1;
				return first + "****" + num + second;
			},
			periodCode() {
				return this.data && this.data.qi ? this.data.qi : "";
			},
			formatCountdown(timeData) {
				// var minutes = timeData.minutes < 10 ? "0" + timeData.minutes : timeData.minutes;
				// var seconds = timeData.seconds < 10 ? "0" + timeData.seconds : timeData.seconds;
				// return minutes + ":" + seconds;
				
				return timeData.minutes*60+timeData.seconds;
			},
			toggleHistory() {
				this.historyOpen = !this.historyOpen;
			},
			toggleOption(key) {
				this[key] = this[key] == 1 ? 0 : 1;
			},
			optionImageSource(key) {
				var image = this.data && this.data[key];
				return typeof image === 'string' ? image.trim() : '';
			},
			hasOptionImage(key) {
				return !!this.optionImageSource(key) && !this.optionImageErrors[key];
			},
			markOptionImageFailed(key) {
				this.$set(this.optionImageErrors, key, true);
			},
			selectedCount() {
				return Number(this.da) + Number(this.xiao) + Number(this.dan) + Number(this.shuang);
			},
			selectedMoney() {
				var money = parseFloat(this.num);
				if (isNaN(money) || money < 0) {
					money = 0;
				}
				return this.selectedCount() * money;
			},
			historyList() {
				var list = [];
				var source = this.kais && this.kais.length ? this.kais : [];
				for (var i = 0; i < source.length; i++) {
					list.push(this.createHistoryRow(source[i], i));
				}
				if (!list.length) {
					var baseCode = parseInt(this.periodCode(), 10) || 202606093441;
					for (var j = 1; j <= 16; j++) {
						list.push(this.createHistoryRow({
							ino: baseCode - j,
							da: j % 3 === 0 ? 1 : 0,
							dan: j % 4 === 0 ? 0 : 1
						}, j));
					}
				}
				return list;
			},
			createHistoryRow(item, index) {
				var code = item.ino || item.qi || item.id || (parseInt(this.periodCode(), 10) - index - 1);
				var firstKey = parseInt(item.da, 10) === 1 ? 'lily' : 'rose';
				var secondKey = parseInt(item.dan, 10) === 1 ? 'balloon' : 'fireworks';
				var digits = this.createVisualDigits(code, index);
				var total = digits.reduce(function(sum, digit) {
					return sum + digit;
				}, 0);
				return {
					code: code,
					digits: digits,
					total: total,
					firstKey: firstKey,
					secondKey: secondKey,
					first: this.$t('buyMission.' + firstKey),
					second: this.$t('buyMission.' + secondKey)
				};
			},
			createVisualDigits(code, index) {
				var raw = String(code || "").replace(/\D/g, "");
				var seed = raw.slice(-3);
				if (seed.length < 3) {
					seed = (seed + String(index + 137)).slice(0, 3);
				}
				var digits = [];
				for (var i = 0; i < 3; i++) {
					var digit = parseInt(seed.charAt(i), 10);
					if (isNaN(digit)) {
						digit = index + i + 1;
					}
					digits.push((digit % 6) + 1);
				}
				return digits;
			},
			graptime(randomInt) {
				this.currentRate += randomInt;
				if (this.currentRate < 100) {
					setTimeout(() => {
						this.graptime(randomInt);
					}, 1000);
				} else {
					this.show1 = false;
					this.start();
					this.accinfo();
				}
			},
			finish() {
				this.show1 = true;
				var randomInt = Math.floor(Math.random() * 20) + 10;
				this.currentRate = 0;
				this.graptime(randomInt);
			},
			accinfo() {
				Fetch('/user/info').then((r) => {
					this.acc = r.data;
				});
			},
			maxnum() {
				// this.number = this.data.max;
			},
			start() {
				Fetch('/index/item_detail', {
					id: this.index
				}).then(res => {
					this.data = res.data;
					this.optionImageErrors = {
						p1: false,
						p2: false,
						p3: false,
						p4: false
					};
					this.vip = res.data.vip;
					this.kais = res.data.kais;
					if (this.kais) {
						this.kai = this.kais[0];
					}
					this.topit = this.historyList()[0] || null;
				});
				Fetch('/index/itemslist').then(res => {
					this.items = res.data;
				});
			},
			buy() {
				if (this.submitting) {
					return false;
				}
				var amount = this.da + this.xiao + this.dan + this.shuang;
				var money = parseFloat(this.num);
				if (amount == 0) {
					this.$toast(this.$t('pro.seltype'));
					return false;
				}
				if (isNaN(money) || money < 1) {
					this.$toast(this.$t('pro.minmoney0'));
					return false;
				}
				amount = amount * money;
				if (this.acc && amount > Number(this.acc.money || 0)) {
					this.$toast(this.$t('pro.insufficient'));
					return false;
				}
				// Dialog.confirm({
				// 	title: '',
				// 	confirmButtonText: this.$t('utils.confirm'),
				// 	cancelButtonText: this.$t('utils.cancel'),
				// 	message: this.$t('pro.issubmit')
				// }).then(() => {
					this.submitting = true;
					Fetch("/user/item_buy", {
						id: this.data.id,
						money: this.num,
						da: this.da,
						xiao: this.xiao,
						dan: this.dan,
						shuang: this.shuang
					}).then(r => {
						if (r.data && r.data > 0) {
							this.$router.push("/invest");
						} else {
							this.$toast(this.$t('pro.succ'));
							this.$router.push("/order");
						}
					}).catch(() => {}).then(() => {
						this.submitting = false;
					});
				// }).catch(() => {});
				return true;
			}
		}
	};
</script>

<style lang="less" scoped>
	.mission-page {
		min-height: 100vh;
		overflow-x: hidden;
		background: #fff;
		color: #16223a;
		box-sizing: border-box;
		padding-bottom: 42px;
	}

	.mission-page.has-bet-sheet {
		padding-bottom: 230px;
	}

	.mission-header {
		height: 50px;
		display: grid;
		grid-template-columns: 64px 1fr 64px;
		align-items: center;
		background: #fff;
		border-bottom: 1px solid #f0f2f5;
		box-sizing: border-box;
	}

	.mission-header h1 {
		margin: 0;
		color: #16223a;
		font-size: 14px;
		font-weight: 500;
		line-height: 22px;
		text-align: center;
	}

	.header-btn {
		width: 100%;
		height: 100%;
		border: 0;
		background: transparent;
		color: #ff5d7a;
		font-size: 14px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.mission-content {
		padding: 30px 0 0;
		box-sizing: border-box;
	}

	.round-section {
		color: #16223a;
		margin-left: 23px;
	}

	.round-label {
		font-size: 14px;
		font-weight: 700;
		line-height: 22px;
	}

	.round-title {
		margin-top: 10px;
		display: flex;
		align-items: baseline;
		gap: 8px;
		font-size: 14px;
		line-height:35px;
	}

	.round-title strong {
		font-size: 14px;
		font-weight: 800;
		letter-spacing: 0;
	}

	.round-time {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		min-width: 72px;
		height: 33px;
		margin-top: 14px;
		padding: 0 8px;
		border: 1px solid rgba(255, 93, 122, 0.26);
		border-radius: 4px;
		background: rgba(255, 93, 122, 0.12);
		box-sizing: border-box;
		color: #ff5d7a;
		font-size: 14px;
		font-weight: 700;
	}

	.round-time /deep/ .van-count-down {
		color: #ff5d7a;
		font-size: 14px;
		font-weight: 700;
		line-height: 31px;
	}

	.round-bar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 30px 15px;
		color: #6d7688;
		font-size: 14px;
		line-height: 20px;
		margin-bottom: 15px;
	}

	.round-bar strong {
		font-weight: 700;
	}

	.history-toggle {
		border: 0;
		background: transparent;
		color: #ff5d7a;
		display: inline-flex;
		align-items: center;
		gap: 4px;
		padding: 0;
		font-size: 14px;
		font-weight: 600;
		line-height: 20px;
	}

	.reservation-panel {
		margin-top: 22px;
		padding: 16px 16px 30px;
		border: 1px solid rgba(255, 93, 122, 0.16);
		border-radius: 10px;
		background: #fff;
		box-sizing: border-box;
		margin: 0 10px;
	}

	.reservation-panel h2 {
		position: relative;
		margin: 0 0 25px;
		padding-left: 13px;
		color: #ff5d7a;
		font-size: 14px;
		font-weight: 800;
		line-height: 22px;
	}

	.reservation-panel h2:before {
		content: "";
		position: absolute;
		left: 0;
		top: 2px;
		width: 5px;
		height: 23px;
		background: #ff5e76;
	}

	.option-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 26px 16px;
	}

	.mission-option {
		position: relative;
		height: 136px;
		padding: 0 5px;
		border: 2px solid rgba(255, 93, 122, 0.16);
		border-radius: 10px;
		background: #fff6f8;
		color: #16223a;
		display: grid;
		grid-template-columns: 82px minmax(0, 1fr);
		align-items: center;
		column-gap: 10px;
		text-align: left;
		box-sizing: border-box;
		overflow: hidden;
		text-align: center;
		display: block;
	}

	.mission-option img {
		width: 86px;
		height: 86px;
		object-fit: contain;
		justify-self: center;
	}

	.mission-option span:not(.option-check) {
		min-width: 0;
		font-size: 14px;
		font-weight: 500;
		line-height: 22px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.mission-option.checked {
		border-color: #ff5d7a;
	}

	.option-check {
		position: absolute;
		right: 0;
		bottom: 0;
		width: 0;
		height: 0;
		border-left: 36px solid transparent;
		border-bottom: 36px solid #ff5d7a;
	}

	.option-check .van-icon {
		position: absolute;
		right: 3px;
		bottom: -34px;
		color: #16223a;
		font-size: 14px;
		font-weight: 800;
	}

	.history-board {
		margin-top: 10px;
		padding: 0 8px;
		border: 1px solid #ffd3d9;
		background: #fff;
		color: #000;
		box-sizing: border-box;
	}

	.history-row {
		min-height: 35px;
		display: grid;
		grid-template-columns: minmax(150px, 1.1fr) 72px 72px;
		padding: 5px;
		align-items: center;
		column-gap: 8px;
		border-bottom: 1px solid #d8d8d8;
		box-sizing: border-box;
	}

	.history-row:last-child {
		border-bottom: 0;
	}

	.history-code {
		min-width: 0;
		font-size: 14px;
		line-height: 20px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.history-digits {
		display: flex;
		gap: 9px;
		color: #e4b98f;
		font-size: 14px;
		font-weight: 800;
		line-height: 22px;
	}

	.history-total {
		width: 33px;
		height: 33px;
		border: 1px solid #efbd8c;
		border-radius: 50%;
		color: #d99d67;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: 700;
		box-sizing: border-box;
	}

	.result-pill {
		min-width: 0;
		height: 25px;
		padding: 0 10px;
		border-radius: 11px;
		color: #fff;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: 800;
		line-height: 16px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.result-pill.is-rose {
		background: #8b42f4;
	}

	.result-pill.is-lily {
		background: #ff5d7a;
	}

	.result-pill.is-fireworks {
		background: #ff766f;
	}

	.result-pill.is-balloon {
		background: #ff5d7a;
	}

	.bet-sheet {
		position: fixed;
		left: 50%;
		bottom: 0;
		z-index: 1;
		width: 100%;
		max-width: 600px;
		padding: 24px 24px 25px;
		border-top: 1px solid #f0f2f5;
		background: #fff;
		box-sizing: border-box;
		transform: translateX(-50%);
	}

	.bet-title {
		display: flex;
		align-items: center;
		color: #ff5d7a;
		font-size: 14px;
		font-weight: 800;
		line-height: 22px;
	}

	.bet-title span {
		height: 23px;
		margin-right: 7px;
	}

	.bet-form {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 18px;
		margin-top: 26px;
	}

	.bet-form label {
		color: #6d7688;
		font-size: 14px;
		font-weight: 500;
		line-height: 20px;
		white-space: nowrap;
	}

	.bet-input {
		width: 180px;
		height: 46px;
		padding: 0 18px;
		border: 1px solid #6d5946;
		border-radius: 26px;
		background: #fff;
		box-sizing: border-box;
		color: #ff5d7a;
		font-size: 14px;
		outline: none;
		text-align: center;
	}

	.bet-submit {
		display: block;
		width: calc(100% - 52px);
		height: 54px;
		margin: 18px auto 0;
		border: 0;
		border-radius: 6px;
		background: linear-gradient(180deg, #ff5d7a 0%, #ff5574 100%);
		color: #fff;
		font-size: 14px;
		font-weight: 800;
		line-height: 22px;
	}

	.bet-submit.disabled {
		opacity: .65;
	}

	.wrapper1 {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100vw;
		height: 100vh;
	}

	.block {
		width: 120px;
		height: 120px;
	}

	/deep/ .van-overlay {
		background-color: rgba(0, 0, 0, .72);
	}

	/deep/ .van-circle__text {
		color: #fff;
		font-size: 14px;
		font-weight: 700;
	}

	@media (max-width: 420px) {
		.mission-content {
			padding:  30px 0 0;
		}

		.round-label {
			font-size: 14px;
		}

		.round-title strong {
			font-size: 14px;
		}

		.round-bar,
		.history-toggle {
			font-size: 12px;
		}

		.reservation-panel {
			padding: 15px 15px 24px;
		}

		.option-grid {
			gap: 24px 16px;
		}

		.mission-option {
			height: 134px;
			grid-template-columns: 84px minmax(0, 1fr);
			padding:0 5px;
		}

		.mission-option img {
			width: 78px;
			height: 78px;
		}

		.history-row {
			grid-template-columns: minmax(150px, 1.1fr) 72px 72px;
			padding: 5px;
			column-gap: 6px;
		}

		.history-code {
			font-size: 14px;
		}

		.history-digits {
			gap: 6px;
			font-size: 14px;
		}

		.result-pill {
			height: 32px;
			padding: 0 8px;
			font-size: 14px;
		}

		.bet-input {
			width: 180px;
		}
	}

	@media (max-width: 360px) {
		.mission-content {
			padding-left: 18px;
			padding-right: 18px;
		}

		.option-grid {
			gap: 18px 14px;
		}

		.mission-option {
			height: 118px;
			grid-template-columns: 70px minmax(0, 1fr);
			padding-right: 18px;
		}

		.mission-option img {
			width: 66px;
			height: 66px;
		}

		.mission-option span:not(.option-check) {
			font-size: 14px;
		}

		.history-row {
			grid-template-columns: minmax(98px, 1fr) 58px 30px 50px minmax(58px, .8fr);
			column-gap: 4px;
		}

		.history-code {
			font-size: 14px;
		}

		.history-digits {
			gap: 4px;
			font-size: 14px;
		}

		.history-total {
			width: 28px;
			height: 28px;
			font-size: 12px;
		}

		.result-pill {
			height: 28px;
			border-radius: 9px;
			font-size: 12px;
		}

		.bet-form {
			gap: 10px;
		}

		.bet-form label {
			font-size: 14px;
		}

		.bet-input {
			width: 180px;
		}
	}

	.mission-page {
		background: #fff;
		color: #16223a;
		padding-bottom: 0px;
	}

	.mission-page.has-bet-sheet {
		padding-bottom: 226px;
	}

	.mission-header {
		height: 56px;
		grid-template-columns: 56px minmax(0, 1fr) 56px;
		background: #fff;
		border-bottom: 1px solid rgba(240, 242, 245, 1);
	}

	.mission-header h1 {
		color: #16223a;
		font-size: 14px;
		font-weight: 700;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.header-btn {
		color: #ff5d7a;
	}

	.header-btn .van-icon {
		width: 36px;
		height: 36px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background: rgba(255, 93, 122, 0.12);
	}

	.mission-content {
		padding: 16px 16px 20px;
	}

	.round-section {
		margin: 0;
		padding: 18px 20px;
		border-radius: 14px;
		border: 1px solid rgba(255, 93, 122, 0.16);
		background: #fff;
		box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
	}

	.round-label {
		color: #6d7688;
		font-size: 14px;
		font-weight: 600;
	}

	.round-title {
		margin-top: 0px;
		color: #6d7688;
	}

	.round-title strong {
		color: #ff5d7a;
		font-size: 16px;
		font-weight: bold;
	}

	.round-title span {
		color: #16223a;
	}

	.round-time {
		min-width: 92px;
		height: 34px;
		margin-top: 0px;
		border-color: rgba(255, 93, 122, 0.26);
		border-radius: 17px;
		background: rgba(255, 93, 122, 0.12);
		color: #ff5d7a;
	}

	.round-time /deep/ .van-count-down {
		color: #ff5d7a;
		font-size: 14px;
		font-weight: 700;
		line-height: 32px;
	}

	.round-bar {
		min-height: 42px;
		margin: 12px 0 14px;
		padding: 5px 12px;
		border-radius: 13px;
		border: 1px solid rgba(255, 93, 122, 0.18);
		background: #fff0f4;
		color: #6d7688;
		box-sizing: border-box;
	}

	.history-toggle {
		min-width: 0;
		color: #ff5d7a;
		font-size: 12px;
		font-weight: 700;
	}

	.reservation-panel,
	.history-board {
		margin: 0;
		border-radius: 14px;
		border: 1px solid rgba(255, 93, 122, 0.16);
		background: #fff;
		box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
	}

	.reservation-panel {
		padding: 16px 14px 18px;
	}

	.reservation-panel h2 {
		margin-bottom: 14px;
		padding-left: 0;
		color: #ff5d7a;
		font-size: 14px;
		line-height: 22px;
	}

	.reservation-panel h2:before {
		display: none;
	}

	.option-grid {
		gap: 10px;
	}

	.mission-option {
		min-height:100px;
		height: auto;
		padding: 12px 10px;
		grid-template-columns: 66px minmax(0, 1fr);
		column-gap: 10px;
		border: 1px solid rgba(255, 93, 122, 0.16);
		border-radius: 12px;
		background: #fff6f8;
		color: #16223a;
		box-shadow: inset 0 1px 0 rgba(255, 255, 255, .06);
	}

	.mission-option img {
		width: 58px;
		height: 58px;
		padding: 5px;
		border-radius: 10px;
		background: rgba(255, 93, 122, 0.12);
		box-sizing: border-box;
	}

	.mission-option span:not(.option-check) {
		color: #16223a;
		font-size: 14px;
		font-weight: 700;
		line-height: 20px;
		white-space: normal;
		word-break: break-word;
	}

	.mission-option.checked {
		border-color: rgba(255, 93, 122, 0.8);
		background: linear-gradient(180deg, #fff0f4 0%, #fff6f8 100%);
	}

	.mission-option.checked span:not(.option-check) {
		color: #ff5d7a;
	}

	.option-check {
		border-left-width: 34px;
		border-bottom-width: 34px;
		border-bottom-color: #ff5d7a;
	}

	.option-check .van-icon {
		right: 3px;
		bottom: -32px;
		color: #fff;
		font-size: 14px;
	}

	.history-board {
		padding: 0 16px;
		color: #16223a;
	}

	.history-row {
		min-height: 54px;
		grid-template-columns: minmax(0, 1fr) auto auto;
		padding: 10px 0;
		column-gap: 8px;
		border-bottom: 1px solid rgba(240, 242, 245, 1);
	}

	.history-code {
		color: #6d7688;
		font-size: 12px;
	}

	.result-pill {
		min-width: 62px;
		height: 30px;
		padding: 0 12px;
		border-radius: 8px;
		border: 1px solid rgba(255, 93, 122, 0.42);
		background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
		color: #fff;
		font-size: 12px;
		line-height: 30px;
	}

	.result-pill.is-rose,
	.result-pill.is-lily,
	.result-pill.is-fireworks,
	.result-pill.is-balloon {
		background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
	}

	.bet-sheet {
		max-width: 600px;
		padding: 18px 16px 20px;
		border-top: 1px solid rgba(255, 93, 122, 0.16);
		background: #fff;
		box-shadow: 0 -16px 28px rgba(22, 34, 58, 0.12);
	}

	.bet-title {
		color: #ff5d7a;
		font-size: 14px;
	}


	.bet-form {
		justify-content: space-between;
		gap: 10px;
		margin-top: 14px;
		padding: 12px 14px;
		border-radius: 12px;
		border: 1px solid rgba(255, 93, 122, 0.16);
		background: #fff6f8;
		box-sizing: border-box;
	}

	.bet-form label {
		min-width: 0;
		max-width: 42%;
		flex: 0 1 auto;
		color: #6d7688;
		font-size: 14px;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.bet-input {
		width: auto;
		height: 40px;
		min-width: 0;
		flex: 1 1 0;
		margin-left: 20px;
		border-color: rgba(255, 93, 122, 0.16);
		border-radius: 10px;
		background: #fff;
		color: #ff5d7a;
		font-size: 14px;
		font-weight: 700;
	}

	.bet-submit {
		width: 100%;
		height: 48px;
		margin-top: 14px;
		border: 1px solid rgba(255, 93, 122, 0.36);
		border-radius: 12px;
		background: linear-gradient(180deg, #ff5d7a 0%, #ff5574 100%);
		color: #fff;
		font-size: 14px;
	}

	.block {
		width: 150px;
		height: 150px;
		padding: 16px;
		border-radius: 18px;
		border: 1px solid rgba(255, 93, 122, 0.16);
		background: #fff;
		box-shadow: 0 18px 40px rgba(22, 34, 58, 0.14);
		box-sizing: border-box;
	}

	/deep/ .van-circle__text {
		color: #ff5d7a;
	}

	.bet-input {
		caret-color: #ff5d7a;
		outline: none;
	}

	.bet-input:focus {
		border-color: rgba(255, 93, 122, 0.52);
		box-shadow: 0 0 0 3px rgba(255, 93, 122, 0.1);
	}

	.bet-input:-webkit-autofill,
	.bet-input:-webkit-autofill:hover,
	.bet-input:-webkit-autofill:focus {
		-webkit-text-fill-color: #ff5d7a;
		box-shadow: 0 0 0 1000px #fff inset;
		caret-color: #ff5d7a;
	}

	@media (max-width: 420px) {
		.mission-content {
			padding: 16px 16px 20px;
		}

		.round-label,
		.round-bar,
		.history-toggle {
			font-size: 12px;
		}

		.round-title strong {
			font-size: 14px;
		}

		.reservation-panel {
			padding: 16px 12px 18px;
		}

		.option-grid {
			gap: 10px;
		}

		.mission-option {
			min-height: 108px;
			height: auto;
			grid-template-columns: 60px minmax(0, 1fr);
			padding: 10px 8px;
		}

		.mission-option img {
			width: 54px;
			height: 54px;
		}

		.result-pill {
			height: 30px;
			font-size: 12px;
		}

		.bet-input {
			width: auto;
			flex: 1 1 0;
		}
	}

	@media (max-width: 360px) {
		.mission-content {
			padding-right: 12px;
			padding-left: 12px;
		}

		.option-grid {
			gap: 8px;
		}

		.mission-option {
			min-height: 96px;
			grid-template-columns: 50px minmax(0, 1fr);
			padding-right: 8px;
		}

		.mission-option img {
			width: 46px;
			height: 46px;
		}

		.mission-option span:not(.option-check) {
			font-size: 12px;
			line-height: 18px;
		}

		.history-row {
			grid-template-columns: minmax(0, 1fr) 54px 54px;
		}

		.result-pill {
			min-width: 54px;
			padding: 0 8px;
		}
	}
	.live-vote-panel {
		margin: 12px 16px 24px;
		overflow: hidden;
		border: 1px solid rgba(255, 93, 122, 0.18);
		border-radius: 16px;
		background: #fff;
		box-shadow: 0 16px 28px rgba(22, 34, 58, 0.08);
		box-sizing: border-box;
	}
	
	.live-vote-title {
		height: 58px;
		line-height: 58px;
		text-align: center;
		background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
		color: #fff;
		font-size: 14px;
		font-weight: 700;
	}
	
	.live-vote-body {
		height: 388px;
		overflow: hidden;
	}
	
	.live-vote-track {
		animation: liveVoteScroll 18s linear infinite;
	}
	
	.live-vote-row {
		background: #fff;
		min-height: 56px;
		padding: 12px 18px;
		box-sizing: border-box;
		color: #566174;
		font-size: 12px;
		font-weight: 500;
		line-height: 22px;
		display: flex;
		align-items: center;
	}
	
	.live-vote-row:nth-child(even) {
		background: #fff6f8;
	}
	@keyframes liveVoteScroll {
		0% {
			transform: translateY(0);
		}
	
		100% {
			transform: translateY(-50%);
		}
	}

	.mission-page {
		--accent: #ff5d7a;
		--accent-strong: #ff4f70;
		--accent-soft: #fff1f5;
		--accent-line: #ffdbe4;
		--text: #16223a;
		--muted: #5d677a;
		--card-shadow: 0 12px 28px rgba(255, 93, 122, 0.13);
		--soft-shadow: 0 10px 24px rgba(255, 93, 122, 0.09);
		background: linear-gradient(180deg, #ff748f 0%, #ff5574 100%);
		color: var(--text);
	}

	.mission-header {
		background: transparent;
		border-bottom-color: rgba(255, 255, 255, 0.18);
	}

	.mission-header h1 {
		color: #fff;
	}

	.header-btn {
		color: #fff;
	}

	.header-btn .van-icon {
		background: rgba(255, 255, 255, 0.18);
		box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.28);
	}

	.round-section {
		border-color: rgba(255, 255, 255, 0.34);
		background: linear-gradient(135deg, rgba(255, 255, 255, 0.18) 0%, rgba(255, 255, 255, 0.07) 100%);
		box-shadow: 0 10px 22px rgba(184, 35, 64, 0.16);
		color: #fff;
	}

	.round-label,
	.round-title,
	.round-title span {
		color: rgba(255, 255, 255, 0.9);
	}

	.round-title strong {
		color: #fff;
	}

	.round-time {
		border-color: rgba(255, 255, 255, 0.72);
		background: rgba(255, 255, 255, 0.92);
		color: var(--accent);
	}

	.round-time /deep/ .van-count-down {
		color: var(--accent);
	}

	.round-bar,
	.reservation-panel,
	.history-board,
	.live-vote-panel {
		border-color: var(--accent-line);
		background: #fff;
		box-shadow: var(--card-shadow);
	}

	.round-bar {
		background: var(--accent-soft);
		color: var(--muted);
	}

	.history-toggle,
	.reservation-panel h2,
	.bet-title {
		color: var(--accent);
	}

	.mission-option {
		border-color: var(--accent-line);
		background: var(--accent-soft);
		box-shadow: none;
	}

	.mission-option img {
		background: rgba(255, 93, 122, 0.12);
	}

	.mission-option.checked {
		border-color: rgba(255, 93, 122, 0.82);
		background: linear-gradient(180deg, #fff 0%, #fff1f5 100%);
		box-shadow: 0 10px 18px rgba(255, 85, 116, 0.18);
	}

	.mission-option.checked span:not(.option-check) {
		color: var(--accent-strong);
	}

	.option-check {
		border-bottom-color: var(--accent);
	}

	.history-code,
	.bet-form label,
	.live-vote-row {
		color: var(--muted);
	}

	.result-pill,
	.result-pill.is-rose,
	.result-pill.is-lily,
	.result-pill.is-fireworks,
	.result-pill.is-balloon,
	.live-vote-title,
	.bet-submit {
		background: linear-gradient(180deg, #ff7892 0%, #ff5574 100%);
	}

	.bet-sheet {
		border-top-color: var(--accent-line);
		box-shadow: 0 -16px 28px rgba(184, 35, 64, 0.16);
	}

	.bet-form {
		justify-content: flex-start;
		border-color: var(--accent-line);
		background: linear-gradient(180deg, #fff 0%, #fff8fa 100%);
	}

	.bet-input {
		width: auto;
		min-width: 0;
		max-width: none;
		flex: 1 1 0;
		border-color: var(--accent-line);
		color: var(--accent);
	}

	.live-vote-row:nth-child(even) {
		background: var(--accent-soft);
	}

	@media (max-width: 360px) {
		.mission-content {
			padding-right: 12px;
			padding-left: 12px;
		}
	}

	.option-grid {
		gap: 18px 16px;
	}

	.mission-option {
		min-height: 154px;
		padding: 14px 10px 12px;
		border: 1px solid transparent;
		border-radius: 14px;
		background: #fff;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 8px;
		overflow: hidden;
		transition: background .2s ease, color .2s ease, box-shadow .2s ease;
	}

	.mission-option img,
	.option-image-placeholder {
		width: 88px;
		height: 88px;
		padding: 0;
		border: 0;
		border-radius: 0;
		background: transparent;
		object-fit: contain;
		box-sizing: border-box;
	}

	.option-image-placeholder {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border-radius: 12px;
		background: #fff1f5;
		color: #ff5d7a;
		font-size: 28px;
	}

	.mission-option span:not(.option-check):not(.option-image-placeholder) {
		color: #000;
		font-size: 14px;
		font-weight: 700;
		line-height: 20px;
	}

	.mission-option.checked {
		border-color: transparent;
		background: linear-gradient(135deg, #e94ba0 0%, #f99c35 100%);
		box-shadow: 0 10px 18px rgba(240, 93, 109, .2);
	}

	.mission-option.checked span:not(.option-check):not(.option-image-placeholder) {
		color: #fff;
	}

	.mission-option.checked .option-image-placeholder {
		background: rgba(255, 255, 255, .2);
		color: #fff;
	}

	@media (max-width: 360px) {
		.option-grid {
			gap: 12px;
		}

		.mission-option {
			min-height: 132px;
			padding: 10px 6px;
		}

		.mission-option img,
		.option-image-placeholder {
			width: 70px;
			height: 70px;
		}
	}

	.mission-page {
		background: #fbf9fc url(../images/ban5/g.png) no-repeat top center / 100% auto;
		padding-bottom: 72px;
	}

	.mission-header {
		background: transparent;
		border-bottom: 0;
	}

	.mission-header h1 {
		color: #000;
	}

	.header-btn {
		color: #121212;
	}

	.header-btn .van-icon {
		background: transparent;
		box-shadow: none;
	}

	.round-section,
	.reservation-panel,
	.history-board,
	.live-vote-panel {
		border-color: rgba(248, 50, 140, .08);
		background: #fff;
		box-shadow: 0 10px 22px rgba(109, 59, 196, .08);
	}

	.round-section {
		color: #16223a;
	}

	.round-label,
	.round-title,
	.round-title span,
	.round-title strong {
		color: #16223a;
	}

	.round-time {
		border-color: rgba(248, 50, 140, .16);
		background: #fff1f7;
		color: #f8328c;
	}

	.round-time /deep/ .van-count-down {
		color: #f8328c;
	}

	.round-bar {
		border-color: rgba(248, 50, 140, .08);
		background: #fff;
		box-shadow: 0 6px 16px rgba(109, 59, 196, .04);
	}

	.history-toggle,
	.reservation-panel h2,
	.bet-title {
		color: #f8328c;
	}

	.mission-option {
		background: #fff;
	}

	.mission-option.checked,
	.result-pill,
	.result-pill.is-rose,
	.result-pill.is-lily,
	.result-pill.is-fireworks,
	.result-pill.is-balloon,
	.live-vote-title,
	.bet-submit {
		background: linear-gradient(100deg, #df4ab7 0%, #6d3bc4 100%);
	}

	.bet-sheet {
		background: #fff;
		border-top-color: rgba(248, 50, 140, .1);
		box-shadow: 0 -10px 24px rgba(109, 59, 196, .08);
	}

	.history-board {
		padding: 8px 14px;
	}

	.history-row {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 12px;
		min-height: 56px;
		padding: 10px 0;
	}

	.history-row .result-pill {
		flex: 0 1 132px;
		min-width: 0;
		height: 34px;
		padding: 0 14px;
		line-height: 34px;
		justify-content: center;
		border-radius: 10px;
	}

	@media (max-width: 360px) {
		.history-board {
			padding: 8px 10px;
		}

		.history-row {
			gap: 8px;
		}

		.history-row .result-pill {
			flex-basis: 110px;
			padding: 0 8px;
		}
	}
</style>
